import PreviewTitleCard, { PreviewTitleCardProps } from '@anm/components/PreviewTitleCard';
import { useCallback, FC } from 'react';

import routes from '../../routes';

import CalendarEventWrapper from './Wrapper';

const { Link } = routes;

const CalendarEvent: FC<PreviewTitleCardProps> = props => {
  const { children, link } = props;

  const renderLink = useCallback(
    (nestedChildren?: JSX.Element) => {
      if (!link) return null;

      return (
        <Link {...link}>
          <a>{nestedChildren || children}</a>
        </Link>
      );
    },
    [link, children]
  );

  return (
    <CalendarEventWrapper>
      <PreviewTitleCard {...{ ...props, renderLink }} weight="normal" />
    </CalendarEventWrapper>
  );
};

export default CalendarEvent;
